import { render } from "./InputWithLabel.vue?vue&type=template&id=1ff1d633&scoped=true"
import script from "./InputWithLabel.vue?vue&type=script&lang=js"
export * from "./InputWithLabel.vue?vue&type=script&lang=js"

import "./InputWithLabel.vue?vue&type=style&index=0&id=1ff1d633&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff1d633"]])

export default __exports__